import React from 'react';
import PropTypes from 'prop-types';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { Chip, Stack, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const AccordionSummary = ({ children, label, count }) => (
  <MuiAccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ height: 56 }}>
    <Stack direction="row" sx={{ alignItems: 'center', width: '100%' }}>
      <Typography variant="body1">{label}</Typography>
      {children}
      {count !== null && (
        <Chip
          label={count}
          sx={{ backgroundColor: 'graphic.light', height: 20, ml: 'auto', mr: 2 }}
        />
      )}
    </Stack>
  </MuiAccordionSummary>
);

AccordionSummary.propTypes = {
  children: PropTypes.node,
  count: PropTypes.number,
  label: PropTypes.string.isRequired,
};
AccordionSummary.defaultProps = {
  children: null,
  count: null,
};

export default AccordionSummary;
